import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {OrganizationContact} from '../contacts/organization-contact';
import {GoogleService} from './google-service';

@Service()
export class OrganizationContactService {
  private readonly http = inject(HttpClient);
  private readonly googleService = inject(GoogleService);


  private urlBase = environment.serviceUrl;

  public getOrganizationContacts(organizationId: String): Observable<OrganizationContact[]> {
    let url = this.urlBase + 'organizationContact/' + organizationId;
    return this.http.get<OrganizationContact[]>(url, {headers: this.getRequestHeaders()});
  }

  private getRequestHeaders(): HttpHeaders {
    return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  }

}
